import React, {useEffect, useState} from "react";
import {useTitleFromComponent, useDataWithRoute} from "../../../utils/hooks";
import { useVsiAppContext } from "../../../stores/VsiApp";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import Grid from "../../../components/Grid";
import {backupGapAnalysis} from "../../../utils/gridColumnDefs/backups/backupGapAnalysis";
import ActivityGauge from "../../../components/ActivityGauge";
import Highcharts from "highcharts/highstock";
import {genericColors} from "../../../utils/chartUtils";
import styles from "../../../utils/themeStyles";
import {Card, Col, Row} from "reactstrap";

export default function BackupStatus({context, title}) {

    useTitleFromComponent(`${context} / ${title}`);
    const { theme, client, periodId } = useVsiAppContext();

    const basicTextStyle = {
        color: styles[theme].textColor,
        fontFamily: styles[theme].fontFamily,
    };

    const [chartData, setChartData] = useState([]);
    const [chartConfig, setChartConfig] = useState([]);

    let route = `/api/v6/report/backup_protection_gap_analysis_proc?client_id=${client.clientId}&period_id=${periodId}`;

    const [data] = useDataWithRoute(route);

    useEffect(() => {
        let AllSeries = []
        let dataDrill = data?.recordset;
        setChartData(dataDrill);
        const grouping = {};

        dataDrill.forEach(datum => {
            if (!grouping[datum.resource]) {
                grouping[datum.resource] = {};
            };

            Object.keys(datum).forEach(key => {
                if (typeof datum[key] === "number" && !key.endsWith("_id") && datum[key] !== 'resource') {
                    grouping[datum.resource][key] = (grouping?.[datum.resource]?.[key] ?? 0) + datum[key];
                };
            });
        });

        const groupKeys = Object.keys(grouping);

        const newData = groupKeys.map(key => {
            return {
                resource: key,
                total: grouping[key].total,
                protection_configured: grouping[key].protection_configured,
                incomplete: grouping[key].incomplete,
                successful: grouping[key].successful,
                unprotected: grouping[key].unprotected
            }
        });

        newData.forEach(datum => {
            if ((datum['protection_configured'] / datum['total']) === Infinity) {
                var configTotlCheck = 0;
            } else {
                configTotlCheck = ((datum['protection_configured'] / datum['total']) || 0) * 100;
            };

            let firstGauge = configTotlCheck;
            let secondGauge = ((datum['successful'] / datum['protection_configured']) || 0) * 100;
            let thirdGauge = ((datum['incomplete'] / (datum['successful'] + datum['incomplete'])) || 0) * 100;
            if (firstGauge > 100) firstGauge = 100;
            if (secondGauge > 100) secondGauge = 100;
            if (thirdGauge > 100) thirdGauge = 100;

            let series = [{
                name: 'Protection Configured/Total',
                data: [{
                    color: genericColors[0],
                    radius: '112%',
                    innerRadius: '88%',

                    y: firstGauge
                }]
            }, {
                name: 'Protection Successful/Configured',
                data: [{
                    color: genericColors[1],
                    radius: '87%',
                    innerRadius: '63%',

                    y: secondGauge
                }]
            }, {
                name: 'Protection Failed/Unsuccessful',
                data: [{
                    color: genericColors[2],
                    radius: '62%',
                    innerRadius: '38%',

                    y: thirdGauge
                }]
            }];

            var resource;

            if (datum['resource'][0] === 'k') {
                resource = datum['resource'].slice(1)
            } else {
                resource = datum['resource']
            };

            AllSeries.push([resource, series]);
        });
        setChartConfig(AllSeries);
    }, [data]);

    return <Card className={`report-card p-2 nav-card-${theme}`}>
        <VsiH4>Backup Protection Gap Analysis</VsiH4>
        <VsiBubble autobotName='ActivityGauge' autobotInfo={{ data: chartConfig }}>
            <Row className={"my-3 d-flex justify-content-center"}>
                {chartConfig?.map(s => (
                    <Col xs={12} sm={12} md={2} style={{padding: 0, width: '260px'}} key={s[0]}>
                        <ActivityGauge title={s[0]} series={s[1]}/>
                    </Col>
                ))}
            </Row>
            <Row className="justify-content-center">
                <Col xs={12} sm={8} md={6}>
                    <table style={{padding: 0, margin: '0 auto'}}>
                        <tbody>
                            <tr>
                                <td width={25} height={10} style={{backgroundColor: genericColors[0], padding: 0}}>
                                </td>
                                <td width={25}
                                    style={{backgroundColor: Highcharts.color(genericColors[0]).setOpacity(0.3).get()}}></td>
                                <td style={{
                                    color: basicTextStyle.color,
                                    fontSize: 10,
                                    marginLeft: 10,
                                    paddingLeft: 10,
                                }}>Protection
                                    Configured / Total
                                </td>
                            </tr>
                            <tr>
                                <td width={25} height={10} style={{backgroundColor: genericColors[1], padding: 0}}>
                                </td>
                                <td width={25}
                                    style={{backgroundColor: Highcharts.color(genericColors[1]).setOpacity(0.3).get()}}></td>
                                <td style={{
                                    color: basicTextStyle.color,
                                    fontSize: 10,
                                    marginLeft: 10,
                                    paddingLeft: 10
                                }}>Protection Successful / Configured
                                </td>
                            </tr>
                            <tr>
                                <td width={25} height={10} style={{backgroundColor: genericColors[2], padding: 0}}>
                                </td>
                                <td width={25}
                                    style={{backgroundColor: Highcharts.color(genericColors[2]).setOpacity(0.3).get()}}></td>
                                <td style={{
                                    color: basicTextStyle.color,
                                    fontSize: 10,
                                    marginLeft: 10,
                                    paddingLeft: 10
                                }}>Protection Failed / Unsuccessful
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Col>
            </Row>
        </VsiBubble>
        <VsiBubble>
            <Grid
                data={chartData}
                columnDefs={backupGapAnalysis}
            />
        </VsiBubble>
    </Card>
}
